import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import Title from '../../components/Title';
import PageNavigation from './PageNavigation';
import { getPolicies } from '../../redux/slices/settingsSlice';
import { Outlet } from 'react-router-dom';

export default function SettingsPage() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPolicies());
    }, [dispatch]);

    return (
        <div>
            <Helmet>
                <title>Console Defentry - Settings</title>
            </Helmet>
            <Title>Settings</Title>
            <div className="navigation-tabs__bottom-indent-wrapper--32">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
